import { useAuth } from '@guildeducationinc/guild-auth';
import { DefaultTheme, Typography } from '@guildeducationinc/recess';
import styles from './GreetingHeader.module.scss';

const GreetingHeader = () => {
  const { user } = useAuth();
  const greeting = user?.firstName ? `Welcome, ${user?.firstName}!` : 'Welcome!';

  return (
    <Typography color={DefaultTheme.textColor} className={styles.greetingHeader} variant='h1'>
      {`${greeting} Guild is here to help you succeed.`}
    </Typography>
  );
};

export default GreetingHeader;
